import { useRef, useState } from 'react';

const ModalAudio = ({ setShowModal }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play()
        .then(() => setIsPlaying(true))
        .catch(error => {
          console.warn("Автовоспроизведение отклонено:", error);
        });
    }
  };

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleClose = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setIsPlaying(false);
    setShowModal(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button  className="circle-button btn_close" onClick={handleClose} title="Закрыть">❌</button>
        <audio ref={audioRef} src={`${API_BASE_URL}/audio/hello.ogg`} preload="auto" />

        <h2>Приветствуем Вас!</h2>
        <p>
          Для ознакомления предлагаем прослушать аудиоинструкцию для удобного взаимодействия с сайтом.
        </p>

        <div className="modal-buttons">
          {!isPlaying && (
            <button className="circle-button btn_play" onClick={handlePlay} title="Плей">▶️</button>
          )}
          {isPlaying && (
            <button className="circle-button" onClick={handlePause} title="Пауза">⏸️</button>
          )}
          
        </div>
      </div>
    </div>
  );
};

export default ModalAudio;
